import { Context, Effect, Layer } from 'effect';
import * as Url from '../api/url';
import { GetToken } from '../requests/aspectAuthorization/auth/requests';
import { getTokenResolver } from '../requests/aspectAuthorization/auth/resolvers';
export class GetTokenError {
    originalError;
    _tag = 'GetTokenError';
    constructor(originalError) {
        this.originalError = originalError;
    }
}
export const AspectAuthorization = Context.GenericTag('@services/AspectAuthorization');
export class RitzConfigService extends Context.Tag('@fixtuur/backpack/RitzConfigService')() {
}
export const layer = Layer.effect(AspectAuthorization, Effect.gen(function* (_) {
    const ritzConfig = yield* _(RitzConfigService);
    const authUrl = Url.join(ritzConfig.ritzUrl, '/api/v1');
    const getToken = (tenantId) => Effect.request(GetToken({ tenant: tenantId }), getTokenResolver(Url.toString(authUrl))).pipe(Effect.map(res => res.token), Effect.mapError(error => new GetTokenError(error.originalError)));
    return {
        getToken,
    };
}));
